export default __webpack_public_path__ + "static/media/style.css.b49a0633.map";